module.exports = {
  APIKey: '11c9f6'
};



// WEBPACK FOOTER //
// ./src/APIKey.js